import API, { apiErrorMessage } from "../global/api";

// Add FbrSnroTesting
export const getInvoicesRequest = () => {
  return {
    type: "GET_INVOICES_REQUEST",
  };
};
export const getInvoicesSuccess = (data) => {
  return {
    type: "GET_INVOICES_SUCCESS",
    payload: data,
  };
};
export const getInvoicesError = (msg) => {
  return {
    type: "GET_INVOICES_ERROR",
    payload: msg,
  };
};
export const getInvoices = () => {
  return (dispatch) => {
    dispatch(getInvoicesRequest());
    API.post(`/invoice/dashboard-data`)
      .then((res) => {
        let InvoicesList = res.data;
        dispatch(getInvoicesSuccess(InvoicesList));
      })
      .catch((error) => {
        dispatch(getInvoicesError(apiErrorMessage(error)));
      });
  };
};
